app.SearchVacancies = (
    function () {
        var vacancy = {
            Init: function () {
                app.SavedVacancies.Init();
                app.ApplicantRegistration.CesaMapInit(true);
            },
            EmployerCesaFilter: function () {

                function containsNumber(stringList, numberList) {
                    console.log('stringList:', stringList); 
                    var array = stringList.toString().split(',');

                    for (var i = 0; i < numberList.length; i++) {
                        if (array.indexOf(numberList[i]) !== -1) {
                            return true;
                        }
                    }

                    return false;
                }
                function filterEmployerSelectMany() {
                    var selectedCesas = [];
                    $("input[name='SelectedCESAIds']:checked").each(function () {
                        selectedCesas.push($(this).attr("value"));
                    });

                    // don't run the following if there are no values in the array
                    if (selectedCesas.length > 0) {
                        $("input[name='SelectedEmployers']").each(function () {

                            var cesa = $(this).data("cesa");
                            var cesaList = "";
                            if (cesa !== null && cesa != undefined) {
                                var cesaString = cesa.toString();
                                cesaList = cesaString.split(",");
                            }

                            if ($(this).attr("data-role") !== "selectall") { // check this to make sure we don't hide the select all checkbox
                                if (!containsNumber(cesaList, selectedCesas)) {
                                    $(this).prop("checked", false);
                                    $(this).parent().css("display", "none");

                                    // call the function to list out the selected options
                                    app.input.listSelectedSelectMany($(this).parent());
                                } else {
                                    $(this).parent().css("display", "block");

                                }
                            }
                        });
                    } else {
                        // if the array is empty, then make sure that all of the employers are showing
                        $("input[name='SelectedEmployers']:hidden").each(function () {
                            {
                                $(this).parent().show();
                            }
                        });
                    }
                }

                filterEmployerSelectMany();

                $("input[name='SelectedCESAIds']").on("change",
                    function () {
                        filterEmployerSelectMany();
                    });
            }
        };

        return vacancy;
    }()
);